<template>
	<div>
		<FooterBar
			v-show="$route.name === 'home'"
			:version="version"
			v-bind="docProps"
			hide-a11y-link
			hide-cookies-link
			hide-sitemap-link
			hide-legal-notice-link
			hide-cgu-link
			:link-items="linkItems"
		/>
		<FooterBar
			v-show="$route.name !== 'home'"
			:version="version"
			v-bind="docProps"
			:social-media-links="socialMediaLinks"
			hide-a11y-link
			hide-cookies-link
			hide-sitemap-link
			hide-legal-notice-link
			hide-cgu-link
			:link-items="linkItems"
		>
			<p
				class="text--secondary my-6 text-center text-body-2 b-l"
				v-html="$t('components.layout.appFooter.text')"
			/>
		</FooterBar>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { mdiInstagram } from '@mdi/js';
	import { LinkItem } from '@cnamts/vue-dot/src/patterns/FooterBar/types';

	@Component
	export default class AppFooter extends Vue {
		version = process.env.VUE_APP_VERSION;
		docProps = {
			sitemapRoute: '/',
			cguRoute: '/',
			legalNoticeRoute: '/',
			a11yStatementRoute: '/'
		};
		linkItems: LinkItem[] = [
			{
				text: 'Mentions légales et CGU',
				to: ''
			}
		];
		socialMediaLinks = [
			{
				icon: mdiInstagram,
				href: 'https://www.instagram.com/mes_tips_sante/?hl=fr'
			}
		];
	}
</script>
